module.exports = __webpack_public_path__ + "img/icon-x-circle.6a428709.svg";